import { create } from 'zustand';

export type User = {
  id: number;
  name: string;
  phone: string;
  password: string;
  role: 'admin' | 'new_master' | 'senior_master' | 'master' | 'accountant';
  status: 'active' | 'unactive';
  hourly_rate: number;
  place_of_birth: string;
  email: string;
  is_self_employed: boolean;
  comment: string;
  citizenship_id?: number;
  styles?: {
    [className: string]: string;
  };
};

export type Citizenship = {
  id: number;
  name: string;
  status: 'active' | 'unactive';
  styles?: {
    [className: string]: string;
  };
};

export type MastersStoreState = {
  list: { isLoaded: boolean; data: User[] };
  setList: (list: { isLoaded: boolean; data: User[] }) => void;
  putIds: number[];
  setPutIds: (update: (state: number[]) => number[]) => void;
  isPostInProcess: boolean;
  setIsPostInProcess: (isPostInProcess: boolean) => void;
  nameFilter: string;
  setNameFilter: (nameFilter: string) => void;
  statusFilter: 'active' | 'unactive';
  setStatusFilter: (statusFilter: 'active' | 'unactive') => void;
  citizenshipsList: {
    isLoaded: boolean;
    data: Citizenship[];
  };
  setCitizenshipsList: (citizenshipsList: {
    isLoaded: boolean;
    data: Citizenship[];
  }) => void;
  isSubmittable: boolean;
  setIsSubmittable: (isSubmittable: boolean) => void;
  isError: boolean;
  setIsError: (isError: boolean) => void;
};

const useMastersStore = create<MastersStoreState>((set) => ({
  list: {
    isLoaded: false,
    data: [],
  },
  setList: (list) => set({ list }),
  putIds: [],
  setPutIds: (update) =>
    set((state) => ({
      putIds: update(state.putIds),
    })),
  isPostInProcess: false,
  setIsPostInProcess: (isPostInProcess) => set({ isPostInProcess }),
  nameFilter: '',
  setNameFilter: (nameFilter) => set({ nameFilter }),
  statusFilter: 'active',
  setStatusFilter: (statusFilter) => set({ statusFilter }),
  citizenshipsList: {
    isLoaded: false,
    data: [],
  },
  setCitizenshipsList: (citizenshipsList) => set({ citizenshipsList }),
  isSubmittable: false,
  setIsSubmittable: (isSubmittable) => set({ isSubmittable }),
  isError: false,
  setIsError: (isError) => set({ isError }),
}));

export default useMastersStore;
